// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  cursor: pointer;
}
:host ::ng-deep .popover {
  font-size: 14px;
}
@media (max-width: 767px) {
  :host ::ng-deep .popover {
    max-width: 262px;
    width: 262px;
  }
}
:host ::ng-deep .popover {
  max-width: 320px;
  width: 320px;
  right: 0;
}
:host ::ng-deep .popover > .arrow {
  right: 17px;
}
:host ::ng-deep .popover .popover-content {
  padding: 0;
}
:host .applications {
  width: 100%;
  padding: 15px;
  overflow: hidden;
}
:host .applications .application {
  list-style-type: none;
  text-align: center;
  line-height: 1.5em;
  float: left;
  display: inline;
  padding: 5px;
  border: 2px solid transparent;
  /*&.active {
      border: 2px solid \$ac-text-color-blue;
  }*/
  max-width: 100px;
  min-height: 84px;
  width: 33.333%;
}
@media (max-width: 767px) {
  :host .applications .application {
    width: 50%;
  }
}
:host .applications .application:hover {
  border: 2px solid #eee;
}
:host .applications .application .icon {
  display: inline-block;
}
:host .applications .application .title {
  display: block;
  line-height: 20px;
  width: 84px;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_workspace/U2000_workspace/U2000_header/U2000_applicationsmenu/U2000_applicationsmenu.component.scss"],"names":[],"mappings":"AAIA;EACI,eAAA;AAHJ;AAKI;EACI,eAAA;AAHR;AAKQ;EAHJ;IAIQ,gBAAA;IACA,YAAA;EAFV;AACF;AAJI;EAQI,gBAAA;EACA,YAAA;EAEA,QAAA;AAFR;AAIQ;EAEI,WAAA;AAHZ;AAMQ;EACI,UAAA;AAJZ;AAQI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AANR;AAQQ;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EAEA;;IAAA;EAIA,gBAAA;EACA,gBAAA;EACA,cAAA;AARZ;AASY;EAhBJ;IAiBQ,UAAA;EANd;AACF;AAQY;EACI,sBAAA;AANhB;AASY;EACI,qBAAA;AAPhB;AASY;EACI,cAAA;EACA,iBAAA;EAGA,WAAA;AAThB","sourcesContent":["\n@import \"../../../../U2000_style/U2000_style-mixins\";\n@import \"../../../../U2000_style/U2000_style-variables\";\n\n:host {\n    cursor: pointer;\n\n    ::ng-deep .popover {\n        font-size: 14px;\n\n        @media (max-width: $screen-xs-top) {\n            max-width: 262px;\n            width: 262px;\n        }\n\n        max-width: 320px;\n        width: 320px;\n        // left: inherit!important;\n        right: 0;\n\n        >.arrow {\n            // left: inherit!important;\n            right: 17px;\n        }\n\n        .popover-content {\n            padding: 0;\n        }\n    }\n\n    .applications {\n        width:100%;\n        padding: 15px;\n        overflow: hidden;\n\n        .application {\n            list-style-type: none;\n            text-align: center;\n            line-height:1.5em;\n            float:left;\n            display:inline;\n            padding: 5px;\n            border: 2px solid transparent;\n\n            /*&.active {\n                border: 2px solid $ac-text-color-blue;\n            }*/\n\n            max-width: 100px;\n            min-height: 84px;\n            width:33.333%;\n            @media (max-width: $screen-xs-top) {\n                width:50%;\n            }\n\n            &:hover {\n                border: 2px solid #eee;\n            }\n\n            .icon {\n                display: inline-block;\n            }\n            .title {\n                display: block;\n                line-height: 20px;\n                //overflow: hidden;\n                //white-space: nowrap;\n                width: 84px;\n                //text-overflow: ellipsis;\n            }\n        }\n    }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
